// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

// feature-components

//TODO: Make some LayoutComponent for this maybe
export const Route = createFileRoute('/$accountId/_user/energyxplorer')({
  component: () => (
    <ServiceGuard
      serviceNames={['EnergyXplorer', 'PortfolioAnalysis']}
      fallback={<Navigate to="/$accountId" />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  staticData: { crumb: 'glossary:energyxplorer' },
});
